import { AuthState } from '../types';

export const initialState: AuthState = {
  isAuthenticated: false,
  isInitialized: false,
  isReady: false,
  user: null,
  logoutRedirect: false,
};
